module.exports = __webpack_public_path__ + "static/media/lst.aa17ddb8.png";